export function viewURL(url) {
  return url && url.includes("/download/")
    ? url.replace("/download/", "/view/")
    : url;
}
